module.exports = __webpack_public_path__ + "img/t2-c25.089e01b4.png";